import ProjectIndex from './Index.vue'
import DetailsRoutes from './Details/router'
import MembersRoutes from './Members/router'
import DocumentsRoutes from './Documents/router'
import Store from '~store/store'
import _ from 'lodash'

export default [
  {
    name: 'project',
    path: 'project/:project',
    component: ProjectIndex,
    beforeEnter: (to, from, next) => {
      enforceProjectData(to.params.project)
        .then(() => {
          next()
        })
        .catch(() => {
          next({ path: '/' })
        })
    },
    children: [...DetailsRoutes, ...MembersRoutes, ...DocumentsRoutes]
  }
]

export function enforceProjectData(projectId) {
  return new Promise((resolve, reject) => {
    const selectedProject = Store.state.projectsModule.selectedProject
    if (projectId && (_.isEmpty(selectedProject) || selectedProject.id !== projectId)) {
      Store.dispatch('getAllProjectDataById', projectId)
        .then(() => {
          resolve()
        })
        .catch(e => {
          console.error('Error on enforceProjectData', e)
          reject()
        })
    } else {
      resolve()
    }
  })
}
